import { NIL as NIL_UUID } from 'uuid';

/** ページを遷移しても保持し続けるデータの定義 */
export interface GlobalData {
  sessionId: string;
}

export const globalData: GlobalData = { sessionId: NIL_UUID };
